// import createHashHistory from 'history/createHashHistory';
import {createHashHistory} from 'history';
import swal from 'sweetalert2/dist/sweetalert2.min';

const history = createHashHistory({
  getUserConfirmation(message, callback) {
    let messageData;
    try {
      messageData = JSON.parse(message);
    } catch (e) {
      console.warn('Missing alert message data');
      callback(true);
    }

    const {
      title,
      text,
      type,
      showCancelButton,
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick = true,
      allowEscapeKey = true,
    } = messageData;

    swal({
      title,
      text,
      type,
      showCancelButton,
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick,
      allowEscapeKey,
    }).then(result => {
      callback(result.value);
    });
  },
});

export default history;
